import { put, select } from 'redux-saga/effects'

import Loader from 'common/modules/loader'
import Internal from 'common/modules/internal'

import { creators } from '../actions'
import selectors from '../selectors'

export default function* watchPicoReady() {
    const picoInit = yield select(selectors.hasPicoInitialed)

    const loader = yield select(Loader.selectors.loader)

    const scope = loader.user ? 'user' : 'guest'

    const scopedLoader = loader[scope] || null

    if (scopedLoader) {
        yield put(Internal.creators.sendMessage({
            payload: {
                target: '*',
                ...Loader.creators.loaderIsNotFetching(),
            },
        }))

        yield put(Internal.creators.sendMessage({
            payload: {
                target: '*',
                ...Loader.creators.getLoaderSuccess({
                    scope,
                    data: scopedLoader,
                }),
            },
        }))

        if (!picoInit) {
            yield put(creators.picoInit({ origin: 'ready' }))
        }
    }
}
